<template>
  <div class="p-grid">
    <Toast />
    <div class="p-col-12" style="margin-bottom: 5px;">
      <Panel
        class="capital"
        header="Filters"
        key="search_key"
        :toggleable="true"
        :collapsed="false"
      >
        <Toolbar class="">
          <template slot="left">
            <div class="p-col-12 p-lg-4">
              <MultiSelect class="p-mr-2 card-input card-multi" id="carparks"
              v-model="carparks" :options="carpark_list"
              optionLabel="name" :filter="true" placeholder="Select Carparks"/>
            </div>
            <div class="p-col-12 p-lg-4">
              <date-picker
                placeholder="From ~ To"
                v-model="range_date"
                class="p-mr-2"
                range
                @change="onChangeDate"
              ></date-picker>
            </div>
            <div class="p-col-12 p-lg-2">
              <Button
                id="seven_days"
                label="7 Days"
                class="p-button-outlined p-button-plain p-mr-2 filter-btn"
                @click="filter('seven_days')"
              />
            </div>
            <div class="p-col-12 p-lg-2">
              <Button
                id="thirty_days"
                label="30 Days"
                class="p-button-outlined p-button-secondary p-mr-2 filter-btn"
                @click="filter('thirty_days')"
              />
            </div>
          </template>

          <template slot="right">
            <Button label="Update" class="p-button-success" icon="pi pi-refresh" @click="update" />
          </template>
        </Toolbar>
      </Panel>
    </div>

    <div v-if="charts_data == null" class="loader">
      <scale-out class="loader-style"></scale-out>
    </div>

    <div class="p-col-12">
      <spark-lines :key="sparkline_key" v-if="charts_data && user_accesses" :user_accesses="user_accesses" :charts_data="charts_data"></spark-lines>
    </div>

    <div class="p-col-12">
      <stack-bar :key="stackbar_key" v-if="charts_data && user_accesses" :user_accesses="user_accesses" :charts_data="charts_data"></stack-bar>
    </div>

  </div>
</template>

<script>
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import SparkLines from "./Dashboards/sparklines";
import StackBar from "./Dashboards/stackbar";
import ReportService from '../services/ReportService';
import CarParkService from '../services/CarParkService';
import {ScaleOut} from 'vue-loading-spinner';
import UserService from '../services/UserService';

export default {
  
  components: { SparkLines, StackBar, DatePicker, ScaleOut },
  data() {
    return {
      reportService: null,
      carparkService: null,
      charts_data: null,
      range_date: null,
      carparks: null,
      sparkline_key: "sparkline-key",
      stackbar_key: "stackbar-key",
      carpark_list: [],
      user_accesses: this.$store.state.accesses,
      userService: null,
    };
  },
  methods: {
    clearFilterBtns() {
      let btn_lists = Object.entries(document.getElementsByClassName("filter-btn"));
      btn_lists.forEach((element) => {
        element[1].className = "p-button-outlined p-button-secondary p-mr-2 filter-btn p-button p-component"
      });
    },
    onChangeDate() {
      this.clearFilterBtns();
    },
    filter(key) {
      if (key) {
        this.clearFilterBtns();
        this.range_date = null;
        let selected_btn = document.getElementById(key);
        selected_btn.className = "p-button-outlined p-button-plain p-mr-2 filter-btn p-button p-component"
      }

      var _from = new Date();
      var _to = new Date();
  
      switch(key){
        case "seven_days":
          _from.setDate(_to.getDate() - 6);
          this.range_date = [_from, _to];
          break;

        case "thirty_days":
          _from.setDate(_to.getDate() - 29);
          this.range_date = [_from, _to];
          break;

        default:
          _from.setDate(_to.getDate() - 6);
          this.range_date = [_from, _to];
          break;
      }

    },
    update() {
      this.convert_date()
      this.reportService.getDashboard({"carparks": this.carparks, "date": this.range_date}).then(result => {
        if (result.status === 200) {
          this.charts_data = result.data.data.charts;
        }
      });
    },
    convert_date() {
      if (this.range_date && typeof(this.range_date[0]) === 'object') {
        this.range_date[0] = this.range_date[0].toLocaleDateString('en-US');
        this.range_date[1] =  this.range_date[1].toLocaleDateString('en-US');
      }
    }
  },
  created() {
    this.carparkService = new CarParkService();
    this.reportService = new ReportService();
    this.userService = new UserService();
    if (!this.user_accesses){
      let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
      this.userService.getUserAccesses(user_info.id).then(result => {
        if (result.status === 200) {
          let accesses = result.data.accesses;
          this.$store.state.accesses = accesses;
          this.user_accesses = accesses;
        }
      });
    }
    this.filter();
    this.carparkService.listCarparks().then(response => this.carpark_list = response.data.carparks.map(carpark => { 
      return {
        "name": carpark.name,
        "code": carpark.id
      }
    }));
    this.update();
  },
  watch: {
    charts_data: function() {
      this.sparkline_key = Math.floor(Math.random() * 10000000);
      this.stackbar_key = Math.floor(Math.random() * 10000000);
    },
  }
};
</script>

<style scoped lang="scss">
.carpark-item {
  display: flex;
  text-transform: capitalize;

  img {
    width: 20px;
    margin-right: 10px;
    max-height: 17px;
  }
}
.p-dropdown,
.p-button,
.mx-datepicker-range {
  width: 100%;
}
.p-toolbar {
  background: unset;
  border: none;
  padding: unset;
}
.card-multi {
  width: 180px;
}

@media (max-width: 1025px) {
  .card-multi {
    width: 100%;
  }
}
</style>
